import {
    GET_PURCHASEORDER_REQUEST, GET_PURCHASEORDER_SUCCESS, GET_PURCHASEORDER_FAIL,
    CREATE_PURCHASEORDER_REQUEST, CREATE_PURCHASEORDER_SUCCESS, CREATE_PURCHASEORDER_FAIL,
    UPDATE_PURCHASEORDER_REQUEST, UPDATE_PURCHASEORDER_SUCCESS, UPDATE_PURCHASEORDER_FAIL,
    DELETE_PURCHASEORDER_REQUEST, DELETE_PURCHASEORDER_SUCCESS, DELETE_PURCHASEORDER_FAIL
} from "../types/purchaseOrderTypes";
import Axios from 'axios';
import cogoToast from 'cogo-toast';
import APP_CONSTANT from '../../config/constants'

export const deletePurchaseOrder = (id) => async (dispatch) => {

    dispatch({ type: DELETE_PURCHASEORDER_REQUEST });

    try {

        const headerData = {
            "api_token": localStorage.getItem('isloggedIn'),
            "customerNo": localStorage.getItem('customerNumber'),
            "userId": localStorage.getItem('userId'),
            "poReferenceNo": id
        }

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}purchase/purchaseorder/delete`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('isloggedIn'),
                "Access-Control-Allow-Origin": "*"
            }
        });
        dispatch({ type: DELETE_PURCHASEORDER_SUCCESS, payload: data });
        window.location.reload()

    } catch (error) {
        dispatch({ type: DELETE_PURCHASEORDER_FAIL, payload: error.message })
    }
}

export const updatePurchaseOrder = (updatePOData, handleClose) => async (dispatch) => {

    dispatch({ type: UPDATE_PURCHASEORDER_REQUEST });

    try {

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}purchase/purchaseorder/update`, updatePOData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('isloggedIn'),
                "Access-Control-Allow-Origin": "*"
            }
        });
        dispatch({ type: UPDATE_PURCHASEORDER_SUCCESS, payload: data });


        if (data.status === 0) {
            cogoToast.error(data.message, { position: 'top-right' })
        } else {
            cogoToast.success(data.message, { position: 'top-right' }).then(() => {
                window.location.href = '/purchaseorder';
            })
        }

    } catch (error) {
        dispatch({ type: UPDATE_PURCHASEORDER_FAIL, payload: error.message })
        cogoToast.error(error.message, { position: 'top-right' })
    }
}

export const createPurchaseOrder = (createPOData) => async (dispatch) => {

    dispatch({ type: CREATE_PURCHASEORDER_REQUEST });

    try {

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}purchase/purchaseorder/create`, createPOData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('isloggedIn'),
                "Access-Control-Allow-Origin": "*"
            }
        });
        dispatch({ type: CREATE_PURCHASEORDER_SUCCESS, payload: data });

        if (data.status === 0) {
            cogoToast.error(data.message, { position: 'top-right' })
        } else {
            cogoToast.success(data.message, { position: 'top-right' }).then(() => {
                window.location.href = '/purchaseorder';
            })
        }

    } catch (error) {
        dispatch({ type: CREATE_PURCHASEORDER_FAIL, payload: error.message })
    }
}

export const getPurchaseOrder = (id) => async (dispatch) => {
    console.log("in getPurchaseOrder")

    dispatch({ type: GET_PURCHASEORDER_REQUEST });

    try {

        const headerData = (id) => {
            if (id) {
                return {
                    "api_token": localStorage.getItem('isloggedIn'),
                    "customerNo": localStorage.getItem('customerNumber'),
                    "userId": localStorage.getItem('userId'),
                    "poId": id
                }
            } else {
                return {
                    "api_token": localStorage.getItem('isloggedIn'),
                    "customerNo": localStorage.getItem('customerNumber'),
                    "userId": localStorage.getItem('userId'),
                }
            }
        }

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}purchase/purchaseorder/getPurchaseOrders`, headerData(id), {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('isloggedIn'),
                "Access-Control-Allow-Origin": "*"
            }
        });
        dispatch({ type: GET_PURCHASEORDER_SUCCESS, payload: data });


    } catch (error) {
        dispatch({ type: GET_PURCHASEORDER_FAIL, payload: error.message })
    }
}

export const getPurchaseOrderEdit = (id) => async (dispatch) => {

    dispatch({ type: GET_PURCHASEORDER_REQUEST });

    try {

        const headerData = (id) => {
            if (id) {
                return {
                    "api_token": localStorage.getItem('isloggedIn'),
                    "customerNo": localStorage.getItem('customerNumber'),
                    "userId": localStorage.getItem('userId'),
                    "poId": id
                }
            } else {
                return {
                    "api_token": localStorage.getItem('isloggedIn'),
                    "customerNo": localStorage.getItem('customerNumber'),
                    "userId": localStorage.getItem('userId'),
                }
            }
        }

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}purchase/purchaseorder/getPurchaseOrders`, headerData(id), {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('isloggedIn'),
                "Access-Control-Allow-Origin": "*"
            }
        });
        dispatch({ type: GET_PURCHASEORDER_SUCCESS, payload: data });
        return data


    } catch (error) {
        dispatch({ type: GET_PURCHASEORDER_FAIL, payload: error.message })
    }
}

export const getVendorPurchaseOrder = (vendorCode, pageNo, searchString, edit) => async (dispatch) => {

    console.log('getVendorPurchaseOrdergetVendorPurchaseOrdergetVendorPurchaseOrdergetVendorPurchaseOrdergetVendorPurchaseOrder')
    console.log(vendorCode)
    console.log(pageNo)
    console.log(searchString)

    let stringPass = searchString?.length > 0 ? searchString : ''


    dispatch({ type: GET_PURCHASEORDER_REQUEST });

    try {
        const headerData = (vendorData, edit) => {
            if (vendorData && edit) {
                return {
                    "api_token": localStorage.getItem('isloggedIn'),
                    "customerNo": localStorage.getItem('customerNumber'),
                    "userId": localStorage.getItem('userId'),
                    "vendorCode": vendorData.vendorCode,
                    "billId": vendorData.billId,
                    "isUsed": "0",
                    "searchString": stringPass
                }
            } else {
                return {
                    "api_token": localStorage.getItem('isloggedIn'),
                    "customerNo": localStorage.getItem('customerNumber'),
                    "userId": localStorage.getItem('userId'),
                    "vendorCode": vendorCode,
                    "isUsed": "0",
                    "searchString": stringPass
                }
            }
        }

        //const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}purchase/purchaseorder/getPurchaseOrders`, headerData(vendorCode, edit), {
        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}purchase/purchaseorder/getPOPagination?page=${pageNo}`, headerData(vendorCode, edit), {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('isloggedIn'),
                "Access-Control-Allow-Origin": "*"
            }
        });
        dispatch({ type: GET_PURCHASEORDER_SUCCESS, payload: data });

    } catch (error) {
        dispatch({ type: GET_PURCHASEORDER_FAIL, payload: error.message })
    }
}

export const getBillingPurchaseOrder = (vendorCode, pageNo, searchString, edit) => async (dispatch) => {

    let vendoId = localStorage.getItem("vendorId")
    let stringPass = searchString?.length > 0 ? searchString : ''


    dispatch({ type: GET_PURCHASEORDER_REQUEST });

    try {
        const headerData = (vendorData, edit) => {
            if (vendorData && edit) {
                return {
                    "api_token": localStorage.getItem('isloggedIn'),
                    "customerNo": localStorage.getItem('customerNumber'),
                    "userId": localStorage.getItem('userId'),
                    "vendorCode": vendorData.vendorCode,
                    "billId": vendorData.billId,
                    "isUsed": "0",
                    "searchString": stringPass,
                    "search_term" : stringPass,
                    "page_no":pageNo,
                    "limit": 10
                }
            } else {
                return {
                    "api_token": localStorage.getItem('isloggedIn'),
                    "customerNo": localStorage.getItem('customerNumber'),
                    "customer_no": localStorage.getItem('customerNumber'),
                    "userId": localStorage.getItem('userId'),
                    "user_id": localStorage.getItem('userId'),
                    "vendorCode": vendorCode,
                    "vendor_id": vendoId,
                    "isUsed": "0",
                    "searchString": stringPass,
                    "search_term" : stringPass,
                    "page_no":pageNo,
                    "limit": 10
                }
            }
        }

            const { data } = await Axios.post(`${process.env.REACT_APP_BASE_URL}/v1/common-services/order/getPendingPurchaseOrders`, headerData(vendorCode, edit), {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('isloggedIn'),
                "Access-Control-Allow-Origin": "*"
            }
        });
        dispatch({ type: GET_PURCHASEORDER_SUCCESS, payload: data.resultSet });
        return data

    } catch (error) {
        dispatch({ type: GET_PURCHASEORDER_FAIL, payload: error.message })
    }
}